import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["center"];
import { Spinner as SharedSpinner } from '@datacamp/le-shared-components';
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const Spinner = _ref => {
  let {
      center = true
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return center ? ___EmotionJSX("div", {
    className: "dc-u-stretch dc-u-fx dc-u-fx-aic dc-u-fx-jcc"
  }, ___EmotionJSX(SharedSpinner, props)) : ___EmotionJSX(SharedSpinner, props);
};